import { render, staticRenderFns } from "./ProjectRequestTab.vue?vue&type=template&id=c732559e&"
import script from "./ProjectRequestTab.vue?vue&type=script&lang=js&"
export * from "./ProjectRequestTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports